module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "position-relative overflow-hidden"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "loading-overlay"
  }, [_c('b-spinner', {
    attrs: {
      "variant": "primary"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    class: {
      'loading-blur': _vm.loading
    }
  }, [_c('div', {
    staticClass: "d-flex justify-content-between mb-3"
  }, [_c('h4', [_vm._v("Vehicle Utilization")]), _vm._v(" "), _c('div', {
    staticClass: "d-flex"
  }, [_c('b-button-group', {
    staticClass: "mr-3",
    attrs: {
      "size": "sm"
    }
  }, [_c('b-button', {
    attrs: {
      "variant": _vm.viewMode === 'table' ? 'primary' : 'outline-primary'
    },
    on: {
      "click": function($event) {
        _vm.$emit('update:viewMode', 'table')
      }
    }
  }, [_vm._v("\n            Table\n          ")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": _vm.viewMode === 'chart' ? 'primary' : 'outline-primary'
    },
    on: {
      "click": function($event) {
        _vm.$emit('update:viewMode', 'chart')
      }
    }
  }, [_vm._v("\n            Graph\n          ")])], 1), _vm._v(" "), _c('b-form-input', {
    staticClass: "mr-2",
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "value": _vm.localFilter,
      "placeholder": "Filter...",
      "size": "sm"
    },
    on: {
      "input": _vm.onFilterInput
    }
  }), _vm._v(" "), (_vm.viewMode === 'chart') ? _c('div', {
    staticClass: "d-flex align-items-center mr-2"
  }, [_c('span', {
    staticClass: "small font-weight-bold text-muted mr-1"
  }, [_vm._v("Top:")]), _vm._v(" "), _c('b-form-select', {
    staticStyle: {
      "width": "70px"
    },
    attrs: {
      "value": _vm.topN,
      "options": _vm.topNOptions,
      "size": "sm"
    },
    on: {
      "change": function($event) {
        _vm.$emit('update:topN', $event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showExport) ? _c('b-button', {
    staticClass: "shadow-sm font-weight-bold",
    attrs: {
      "variant": "outline-success",
      "size": "sm",
      "disabled": _vm.isExporting || !_vm.items.length
    },
    on: {
      "click": function($event) {
        _vm.$emit('export')
      }
    }
  }, [(_vm.isExporting) ? [_c('b-spinner', {
    staticClass: "mr-1",
    attrs: {
      "small": ""
    }
  }), _vm._v("\n            Exporting…\n          ")] : [_c('i', {
    staticClass: "fa fa-download mr-1"
  }), _vm._v("\n            Excel Export\n          ")]], 2) : _vm._e()], 1)]), _vm._v(" "), (_vm.viewMode === 'chart') ? _c('div', {
    staticClass: "mb-4 pt-4 d-flex justify-content-center"
  }, [_c('apexchart', {
    attrs: {
      "type": "radialBar",
      "height": "880",
      "width": "880",
      "options": _vm.chartOptions,
      "series": _vm.chartSeries
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.viewMode === 'table') ? _c('b-table', {
    staticClass: "custom-table",
    attrs: {
      "items": _vm.items,
      "fields": _vm.fields,
      "filter": _vm.localFilter,
      "hover": "",
      "responsive": ""
    },
    scopedSlots: _vm._u([{
      key: "regNo",
      fn: function(data) {
        return [_c('div', {
          staticClass: "d-flex align-items-center"
        }, [_c('i', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover",
            modifiers: {
              "hover": true
            }
          }],
          staticClass: "fa fa-info-circle text-info mr-2 cursor-pointer",
          attrs: {
            "title": "View Technical Details"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.$emit('open-master-details', data.item)
            }
          }
        }), _vm._v(" "), _c('a', {
          staticClass: "font-weight-bold text-primary vehicle-link",
          attrs: {
            "href": "javascript:void(0)"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.$emit('select-vehicle', data.item.regNo)
            }
          }
        }, [_vm._v("\n              " + _vm._s(data.item.regNo) + "\n          ")])])]
      }
    }, {
      key: "trips",
      fn: function(data) {
        return [(_vm.canOpenTrips(data.item)) ? _c('button', {
          staticClass: "btn btn-link p-0 font-weight-bold text-primary trip-assign-link",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.$emit('open-trip-details', data.item)
            }
          }
        }, [_vm._v("\n          " + _vm._s(data.item.trips) + "\n        ")]) : _c('span', {
          staticClass: "text-muted"
        }, [_vm._v(_vm._s(data.item.trips))])]
      }
    }, {
      key: "totalAssignments",
      fn: function(data) {
        return [(_vm.canOpenAssignments(data.item)) ? _c('button', {
          staticClass: "btn btn-link p-0 font-weight-bold text-primary trip-assign-link",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.$emit('open-assignment-details', data.item)
            }
          }
        }, [_vm._v("\n          " + _vm._s(data.item.totalAssignments) + "\n        ")]) : _c('span', {
          staticClass: "text-muted"
        }, [_vm._v(_vm._s(data.item.totalAssignments != null ? data.item.totalAssignments : 0))])]
      }
    }, {
      key: "performance",
      fn: function(data) {
        return [_c('b-progress', {
          attrs: {
            "value": data.item.performance,
            "variant": "primary",
            "show-progress": "",
            "height": "10px"
          }
        })]
      }
    }, {
      key: "lastLocation",
      fn: function(data) {
        return [_c('div', {
          staticClass: "small d-flex align-items-center location-click",
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.$emit('select-vehicle', data.item.regNo)
            }
          }
        }, [_c('md-icon', {
          staticClass: "mr-1 text-primary",
          attrs: {
            "size": "16"
          }
        }, [_vm._v("place")]), _vm._v(" "), _c('span', {
          staticClass: "location-text"
        }, [_vm._v(_vm._s(data.item.lastLocation))])], 1)]
      }
    }, {
      key: "revenue",
      fn: function(data) {
        return [_c('span', {
          staticClass: "font-weight-bold"
        }, [_vm._v(_vm._s(_vm.formatInr(data.item.revenue)))])]
      }
    }, {
      key: "expense",
      fn: function(data) {
        return [_c('span', [_vm._v(_vm._s(_vm.formatInr(data.item.expense)))])]
      }
    }, {
      key: "actions",
      fn: function(row) {
        return [_c('b-button', {
          attrs: {
            "size": "sm",
            "variant": "outline-primary"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.$emit('open-trip-details', row.item)
            }
          }
        }, [_c('md-icon', [_vm._v("visibility")])], 1)]
      }
    }])
  }) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-484e4508","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/dashboard/VehiclePerformanceDashboard/components/UtilizationTab.vue
// module id = 2589
// module chunks = 0